import gql from 'graphql-tag';

export default gql`
  fragment projectGroupPreleadCustomizeItemSelectOptionFragment on ProjectGroupPreleadCustomizeItemSelectOption {
    id
    label
  }
`;
